// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".breadcrumb[data-v-f89cedae]{margin-bottom:2rem}.breadcrumb .separator[data-v-f89cedae]{font-size:.75rem}@media screen and (min-width:768px){.breadcrumb[data-v-f89cedae]{margin-top:-1rem}}@media screen and (max-width:767px){.feature-container[data-v-f89cedae]{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
